import React from 'react';
import { observer } from 'mobx-react-lite';
import { useIntl } from 'react-intl';

import { DefaultIntlFormatValues } from '@ratehub/base-ui';

import COMMON_MESSAGES from '../definitions/Messages';
import CreditCardShape from '../definitions/CreditCardShape';
import FooterDefaultIntlFormatValues from '../definitions/FooterDefaultIntlFormatValues';
import insertAnniversaryBonusColumn from '../functions/insertAnniversaryBonusColumn';
import getInterestAndMinimumIncomeColumns from '../functions/getInterestAndMinimumIncomeColumns';
import CardFooter from './CardFooter';


function CardFooterTravel({ cardInfo, ...otherProps }) {
    const intl = useIntl();

    const columns = [
        cardInfo.signUpBonusPoints
            ? intl.formatMessage(COMMON_MESSAGES.cardFooterSignUpBonus, {
                ...DefaultIntlFormatValues,
                ...FooterDefaultIntlFormatValues,
                ...cardInfo,
            })
            : null,

        intl.formatMessage(COMMON_MESSAGES.cardFooterAnnualFee, {
            ...DefaultIntlFormatValues,
            ...FooterDefaultIntlFormatValues,
            ...cardInfo,
            zero: 0,
        }),

        ...getInterestAndMinimumIncomeColumns({
            purchaseInterest: cardInfo.purchaseInterest,
            cashAdvanceInterest: cardInfo.cashAdvanceInterest,
            balanceTransferInterest: cardInfo.balanceTransferInterest,

            minimumIncome: cardInfo.minimumIncome,
            minimumCreditScore: cardInfo.minimumCreditScore,
            intl,
        }),
    ];

    insertAnniversaryBonusColumn({ anniversaryBonus: cardInfo.anniversaryBonus, columns, intl });

    return (
        <CardFooter
            columns={columns}
            {...otherProps}
        />
    );
}

CardFooterTravel.propTypes = {
    cardInfo: CreditCardShape.isRequired,
};


export default observer(CardFooterTravel);
